<template
  ><b-progress class="graph_container" :height="heightString" :max="max">
    <b-progress-bar :value="correct" variant="success" />
    <b-progress-bar :value="incorrect" variant="danger" />
    <b-progress-bar :value="omitted" variant="light" />
  </b-progress>
</template>

<script>
export default {
  name: "ResponseGraph",
  props: {
    height: {
      type: Number,
      default: null,
      required: true
    },
    correct: {
      type: Number,
      default: null,
      required: true
    },
    incorrect: {
      type: Number,
      default: null,
      required: true
    },
    omitted: {
      type: Number,
      default: null,
      required: true
    }
  },
  computed: {
    max() {
      return this.correct + this.incorrect + this.omitted;
    },
    heightString() {
      return this.height + "px";
    }
  }
};
</script>

<style scoped>
.graph_container {
  border-radius: 0;
}
</style>
